// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UnavailableIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UnavailableIcon" ref={forwardedRef} {...props}>
      <path d="M17.932 11.045a8 8 0 0 0 0-2.09L15.95 9.214a6 6 0 0 1 0 1.572z" />
      <path d="M17.393 6.938a8 8 0 0 0-1.046-1.808l-1.586 1.218a6 6 0 0 1 .785 1.356z" />
      <path d="M14.87 3.653a8 8 0 0 0-1.808-1.046l-.766 1.848a6 6 0 0 1 1.356.784z" />
      <path d="M11.045 2.068a8 8 0 0 0-2.09 0L9.214 4.05a6 6 0 0 1 1.572 0z" />
      <path d="M6.938 2.607A8 8 0 0 0 5.13 3.653l1.218 1.586a6 6 0 0 1 1.356-.784z" />
      <path d="M3.653 5.13a8 8 0 0 0-1.046 1.808l1.848.766a6 6 0 0 1 .784-1.356z" />
      <path d="M2 10a8 8 0 0 1 .068-1.045L4.05 9.214a6 6 0 0 0 0 1.572l-1.983.259A8 8 0 0 1 2 10" />
      <path d="M2.607 13.062a8 8 0 0 0 1.046 1.808l1.586-1.218a6 6 0 0 1-.784-1.356z" />
      <path d="M5.13 16.347a8 8 0 0 0 1.808 1.046l.766-1.848a6 6 0 0 1-1.356-.784z" />
      <path d="M8.955 17.932a8 8 0 0 0 2.09 0l-.259-1.983a6 6 0 0 1-1.572 0z" />
      <path d="M13.062 17.393a8 8 0 0 0 1.808-1.046l-1.218-1.586a6 6 0 0 1-1.356.785z" />
      <path d="M16.347 14.87a8 8 0 0 0 1.046-1.808l-1.848-.766a6 6 0 0 1-.784 1.356z" />
      <path d="m8.03 13.03 5-5-1.06-1.06-5 5z" />
    </SvgIcon>
  );
});

/**
 * Use to show something is not existing, inactive or not available
 * @public
 */
export const UnavailableIcon = /* @__PURE__ */ Object.assign(
  UnavailableIconComponent,
  { displayName: 'UnavailableIcon' },
);
